<template>
  <div class="hot-sale" id="home-hot-sale">
    <div
      v-for="(item, index) in bestSellersTypes"
      :key="index"
      class="hot-sale-item pointer2"
      @click="bestGoodType(item)"
    >
      <div>
        <div class="t1">{{ item.name }}</div>
        <div class="t2">{{ item.describe }}</div>
      </div>
      <el-image
        class="img"
        :src="item.typeUrl || defaultImg"
        :alt="item.name"
        lazy
        :fit="'contain'"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defaultImg: require("@/assets/img/bitmap.png"),
      bestSellersTypes: [], // 热卖品牌
      //   bestSellersAdvList: [], // 热卖广告
    };
  },
  created() {
    this.getBestSellersType();
  },
  methods: {
    // 获取热卖类目及热卖商品
    getBestSellersType() {
      this.$request
        .get(
          `/front/user/home/homeBestSellersType/findBestSellersTypesForShopping?mobileFlag=0`
        )
        .then((data) => {
          let typeList = [];
          if (data.homeBestSellersTypeVos) {
            typeList =
              data.homeBestSellersTypeVos.length > 8
                ? data.homeBestSellersTypeVos.splice(0, 8)
                : data.homeBestSellersTypeVos;
          }
          this.bestSellersTypes = typeList;
          //   this.bestSellersAdvList = data.homeHotCommodityAdvertisementInfoVos || [];
        });
    },
    // 热卖id跳转
    bestGoodType(item) {
      this.$router.push({
        name: "bestGoodsList",
        query: { id: item.bestSellersTypeId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hot-sale {
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
  .hot-sale-item {
    margin-top: 12px;
    width: 292px;
    height: 136px;
    background: #fff;
    border-radius: 16px;
    border: 1.6px solid #f5f6fa;
    margin-right: 10px;
    padding: 12px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
  .t1 {
    font-family: Alibaba PuHuiTi;
    font-size: 16px;
    font-weight: 500;
    line-height: 21.95px;
    text-align: left;
    color: #333;
  }
  .t2 {
    font-family: Alibaba PuHuiTi;
    font-size: 12px;
    font-weight: 500;
    line-height: 16.46px;
    text-align: left;
    color: #666;
  }
  .img {
    width: 112px;
    height: 112px;
    border-radius: 12px;
    border: 1.6px solid #f5f6fa;
  }
}
</style>
